export const defaultFetch = async (input, init) => fetch(input, init);
//# sourceMappingURL=fetch-function.js.map